// extracted by mini-css-extract-plugin
export var CTAbutton = "CTAbutton-module--CTAbutton--1ALhk";
export var background_Blue = "CTAbutton-module--background_Blue--3lgKc";
export var background_Black = "CTAbutton-module--background_Black--10OPt";